module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400.ea57ba2.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-brands-400.woff
// module id = PdC+
// module chunks = 13 14